/** @jsxImportSource theme-ui */
import { Box, Text, useThemeUI } from "theme-ui";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import get from "lodash/get";

import { useTranslation } from "hooks";
import { selectUserChoices } from "store/app";
import { Button, ImagesButton, PriceNotice } from "components";
import { getHrefWithHostname } from "utils";
import * as styles from "./Product.styles";

export default function ProductDetails({
  product,
  cost,
  standaloneLearnPage,
  selectedImageViewAngle,
  imageViewAnglesObj,
  setSelectedImageAngle,
  showChangeButton = true,
  changeProduct,
}) {
  const {
    theme: { isDesktop },
  } = useThemeUI();

  const { t } = useTranslation();

  const userChoiceValues = useSelector(selectUserChoices);
  const size = get(userChoiceValues, ["Size", "selectedOption", "shortLabel"]);

  return (
    <motion.div
      sx={styles.productDetailsContainerAnimated}
      initial={{
        x: "-100%",
        opacity: 0,
      }}
      animate={{
        x: "0%",
        opacity: 1,
        transition: {
          duration: 0.3,
        },
      }}
    >
      <Box sx={styles.productDetails}>
        <Box
          sx={styles.productName({
            categoryColor: product?.category?.color,
          })}
        >
          <Text>{product.subName || product.name}</Text>

          {size && (
            <Text sx={{ color: "grey5", fontWeight: "light" }}> / {size}</Text>
          )}
        </Box>

        <Box sx={styles.costwithskate}>
          <Text sx={styles.cost}>{cost}</Text>
          {standaloneLearnPage && (
            <>
              <svg
                height={isDesktop ? "24" : "13"}
                width={isDesktop ? "10" : "10"}
              >
                <line x1="10" y1="0" x2="10" y2="24" style={styles.vertical} />
              </svg>
              <Button
                href={getHrefWithHostname(standaloneLearnPage.href)}
                sx={styles.standaloneLearnPage}
                target="_blank"
                rel="noopener noreferrer"
              >
                {standaloneLearnPage.label}
              </Button>
            </>
          )}
          <PriceNotice />
        </Box>

        {isDesktop && showChangeButton && (
          <Button
            size="small"
            isRound
            sx={styles.changeProductButton}
            onClick={changeProduct}
          >
            {t("CHANGE")}
          </Button>
        )}
      </Box>

      {isDesktop && product?.showChangeImageAngleMenu && (
        <ImagesButton
          selectedImageViewAngle={selectedImageViewAngle}
          imageViewAnglesObj={imageViewAnglesObj}
          setSelectedImageAngle={setSelectedImageAngle}
        />
      )}
    </motion.div>
  );
}
